<script setup>
	const baseUrl = useRuntimeConfig().public.NUXT_PUBLIC_SITE_URL;
	const pageTitle = 'Политика конфиденциальности';
	const pageDescription =
		'Политика конфиденциальности персональных данных ООО «Агентство Правильных Перевозок»';

	useSeoMeta({
		title: pageTitle,
		description: pageDescription,
		ogTitle: pageTitle,
		ogDescription: pageDescription,
		ogImage: baseUrl + '/images/og-image.png',
		ogUrl: baseUrl + '/privacy',
		ogType: 'website',
		ogSiteName: 'АПП - Агентство Правильных Перевозок',
		ogLocale: 'ru_RU',
		twitterCard: 'summary_large_image',
		twitterTitle: pageTitle,
		twitterDescription: pageDescription,
	});
</script>

<template>
	<div class="privacy-policy">
		<h1 class="privacy-policy__page-title">Политика конфиденциальности</h1>
		<div class="privacy-policy__content">
			<p class="privacy-policy__content-block">
				Настоящая Политика конфиденциальности персональных данных (далее – «Политика
				конфиденциальности») действует в отношении всей информации, которую компания ООО «Агентство
				Правильных Перевозок» (ИНН 7300030591) может получить о Пользователе во время использования им
				сайта, расположенного по адресу (на доменном имени): https://app73.pro, включая все уровни
				указанного домена и содержащиеся на них страницы (далее – «Сайт»), а также в ходе исполнения
				Администрацией сайта любых соглашений и договоров с Пользователем.
			</p>
			<ol class="privacy-policy__content-block">
				<li class="privacy-policy__lvl-1-text">
					<h2 class="privacy-policy__title-lvl-1">Общие положения</h2>
					<ol type="1" class="privacy-policy__ol-lvl-2">
						<li class="privacy-policy__lvl-2-text">
							Использование Пользователем Сайта означает согласие с настоящей Политикой
							конфиденциальности и условиями обработки персональных данных Пользователя. В
							случае несогласия с условиями Политики конфиденциальности Пользователь должен
							прекратить использование Сайта.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Настоящая Политика конфиденциальности применяется только к Сайту. Данный Сайт не
							контролирует и не несет ответственность за сайты третьих лиц, на которые
							Пользователь может перейти по ссылкам, доступным на Сайте.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Администрация сайта не проверяет достоверность персональных данных,
							предоставляемых Пользователем сайта.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Текст и условия настоящей Политики конфиденциальности в любое время могут быть
							изменены Администрацией сайта без предварительного уведомления. При несогласии
							Пользователя с внесенными изменениями, условиями использования Пользователем
							материалов и сервисов Сайта он обязан отказаться от доступа к Сайту, прекратить
							использование материалов и сервисов Сайта со дня вступления в силу внесенных
							изменений.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Новая Политика конфиденциальности вступает в силу с момента ее размещения на
							Сайте, если иное не предусмотрено новой редакцией Политики конфиденциальности.
							Ссылка на действующую Политику конфиденциальности размещена на всех страницах
							Сайта (внизу каждой страницы Сайта).
						</li>
					</ol>
				</li>
				<li class="privacy-policy__lvl-1-text">
					<h2 class="privacy-policy__title-lvl-1">Предмет политики конфиденциальности</h2>
					<ol type="1" class="privacy-policy__ol-lvl-2">
						<li class="privacy-policy__lvl-2-text">
							Настоящая Политика конфиденциальности устанавливает обязательства Администрации
							сайта по неразглашению и обеспечению режима защиты конфиденциальности персональных
							данных, которые Пользователь предоставляет при использовании Сайта.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Персональные данные, разрешённые к обработке в рамках настоящей Политики
							конфиденциальности, предоставляются Пользователем путём заполнения регистрационных
							форм на Сайте, а также могут собираться для предоставления доступа к функционалу
							Сайта. Пользователь дает согласие на обработку своих персональных данных, не
							являющихся специальными или биометрическими, в том числе, но не ограничиваясь,
							следующими данными: имя, фамилия, номер контактного телефона, адрес электронной
							почты, место работы и его реквизиты, занимаемая должность, пользовательские данные
							(сведения о местоположении, тип и версия операционной системы, тип и версия
							браузера, тип устройства и разрешение его экрана, источник перехода на сайт,
							включая адрес сайта- 2 источника и текст размещенного на нем рекламного объявления
							и/или ссылки, язык операционной системы и браузера, список посещенных страниц и
							выполненных на них действий, IP-адрес, информация из файлов cookies).
						</li>
						<li class="privacy-policy__lvl-2-text">
							Настоящая Политика применима только к информации, обрабатываемой в ходе
							использования Сайта. Администрация сайта не контролирует и не несет
							ответственность за обработку информации сайтами третьих лиц, на которые
							Пользователь может перейти по ссылкам, доступным внутри Сайта.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Администрация сайта не проверяет достоверность персональных данных,
							предоставляемых Пользователем, и не имеет возможности оценивать его
							дееспособность. Однако Администрация сайта исходит из того, что пользователь
							предоставляет достоверные и достаточные персональные данные и поддерживает их в
							актуальном состоянии.
						</li>
					</ol>
				</li>
				<li class="privacy-policy__lvl-1-text">
					<h2 class="privacy-policy__title-lvl-1">
						Цели сбора персональной информации Пользователя
					</h2>
					<ol type="1" class="privacy-policy__ol-lvl-2">
						<li class="privacy-policy__lvl-2-text">
							Администрация сайта обрабатывает персональные данные исключительно для
							предоставления полного или частичного функционала Сайта в соответствии с
							Пользовательским соглашением, для предоставления Пользователю информационных услуг
							и/или для исполнения соглашений и договоров с Пользователем. Администрация сайта
							обрабатывает персональные данные Пользователя в следующих целях:
							<ol type="1" class="privacy-policy__ol-lvl-3">
								<li class="privacy-policy__lvl-2-text">
									для предоставления полного или частичного доступа к материалам и
									функционалу Сайта;
								</li>
								<li class="privacy-policy__lvl-2-text">
									для идентификации Пользователя в ходе обработки заявок на участие,
									оформления и организации участия Пользователя и/или компании,
									представителем которой является Пользователь, в мероприятиях ООО
									«Агентство Правильных Перевозок»;
								</li>
								<li class="privacy-policy__lvl-2-text">
									для исполнения иных соглашений и договоров с Пользователем и/или компании,
									представителем которой является Пользователь;
								</li>
								<li class="privacy-policy__lvl-2-text">
									для предоставления Пользователю уведомлений, новостей, приглашений,
									специальных предложений, информации о мероприятиях и иных сведений от
									имени компании ООО «Агентство Правильных Перевозок»;
								</li>
								<li class="privacy-policy__lvl-2-text">
									для предоставления Пользователю подробной информации о предлагаемых
									услугах и решениях участниками мероприятий, проводимых компанией ООО
									«Агентство Правильных Перевозок»;
								</li>
								<li class="privacy-policy__lvl-2-text">
									для установления с Пользователем обратной связи, включая направление
									уведомлений, запросов, касающихся использования Сайта, обработки запросов
									и заявок от Пользователя;
								</li>
								<li class="privacy-policy__lvl-2-text">
									для предоставления Пользователю эффективной клиентской и технической
									поддержки при возникновении проблем, связанных с использованием Сайта.
								</li>
							</ol>
						</li>
					</ol>
				</li>
				<li class="privacy-policy__lvl-1-text">
					<h2 class="privacy-policy__title-lvl-1">
						Способы и сроки обработки Персональной информации
					</h2>
					<ol type="1" class="privacy-policy__ol-lvl-2">
						<li class="privacy-policy__lvl-2-text">
							При обработке персональных данных Пользователей Администрация сайта
							руководствуется. Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных
							данных» и другими нормативными актами Российской Федерации.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Обработка персональных данных Пользователя осуществляется без ограничения срока,
							любым законным способом, в том числе в информационных системах персональных данных
							с использованием средств автоматизации или без использования таких средств.
							Обработка персональных данных может осуществляться путем сбора, систематизации,
							накопления, хранения, уточнения (обновление, изменение), использования, передачи,
							обезличивания, блокирования, уничтожения.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Согласие на обработку персональных данных может быть отозвано Пользователем путем
							подачи заявления Администрации сайта с указанием сведений, определенных ст. 14
							Закона «О персональных данных». Отзыв согласия на обработку персональных данных
							может быть осуществлен путем направления Пользователем соответствующего заявления
							в свободной письменной форме на адрес электронной почты, указанной в разделе 8
							Политики конфиденциальности.
						</li>
						<li class="privacy-policy__lvl-2-text">
							В отношении персональных данных Пользователя сохраняется их конфиденциальность,
							кроме случаев добровольного предоставления Пользователем информации о себе для
							общего доступа неограниченному кругу лиц.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Пользователь или его законный представитель вправе требовать блокировки или
							уничтожения предоставленных персональных данных в случае отказа от использования
							Сайта и/или отказа от участия в мероприятиях ООО «Агентство Правильных Перевозок»,
							направив соответствующий запрос по электронной почте, указанной в разделе 8
							Политики конфиденциальности.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Администрация сайта принимает необходимые организационные и технические меры для
							защиты персональной информации Пользователя от неправомерного или случайного
							доступа, уничтожения, изменения, блокирования, копирования, распространения, а
							также от иных неправомерных действий третьих лиц.
						</li>
					</ol>
				</li>
				<li class="privacy-policy__lvl-1-text">
					<h2 class="privacy-policy__title-lvl-1">Обязательства сторон</h2>
					<ol type="1" class="privacy-policy__ol-lvl-2">
						<li class="privacy-policy__lvl-2-text">
							Пользователь обязан:
							<ol type="1" class="privacy-policy__ol-lvl-3">
								<li class="privacy-policy__lvl-2-text">
									Предоставить информацию о персональных данных, необходимую для пользования
									Сайтом и организации участия Пользователя и/или компании, представителем
									которой является Пользователь, в мероприятиях, проводимых компанией ООО
									«Агентство Правильных Перевозок»;
								</li>
								<li class="privacy-policy__lvl-2-text">
									Обновить, дополнить предоставленную информацию о персональных данных в
									случае изменения данной информации.
								</li>
							</ol>
						</li>
						<li class="privacy-policy__lvl-2-text">
							Администрация сайта обязана:
							<ol type="1" class="privacy-policy__ol-lvl-3">
								<li class="privacy-policy__lvl-2-text">
									Использовать полученную информацию исключительно для целей, указанных в
									Разделе 4 настоящей Политики конфиденциальности.
								</li>
								<li class="privacy-policy__lvl-2-text">
									Обеспечить хранение конфиденциальной информации в тайне, не разглашать без
									предварительного письменного разрешения Пользователя, а также не
									осуществлять продажу, обмен, опубликование, либо разглашение иными
									возможными способами переданных персональных данных Пользователя, за
									исключением п.п. 5.4., 5.5. и 5.6. настоящей Политики Конфиденциальности.
								</li>
								<li class="privacy-policy__lvl-2-text">
									Принимать меры предосторожности для защиты конфиденциальности персональных
									данных Пользователя согласно порядку, обычно используемого для защиты
									такого рода информации в существующем деловом обороте.
								</li>
								<li class="privacy-policy__lvl-2-text">
									Осуществить блокирование персональных данных, относящихся к
									соответствующему Пользователю, с момента обращения или запроса
									Пользователя, или его законного представителя либо уполномоченного органа
									по защите прав субъектов персональных данных на период проверки, в случае
									выявления недостоверных персональных данных или неправомерных действий.
								</li>
							</ol>
						</li>
					</ol>
				</li>
				<li class="privacy-policy__lvl-1-text">
					<h2 class="privacy-policy__title-lvl-1">Заключительные положения</h2>
					<ol type="1" class="privacy-policy__ol-lvl-2">
						<li class="privacy-policy__lvl-2-text">
							Настоящая Политика конфиденциальности регулируется и толкуется в соответствии с
							законодательством Российской Федерации. Вопросы, не урегулированные Политикой
							конфиденциальности, подлежат разрешению в соответствии с законодательством
							Российской Федерации.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Все споры и разногласия в отношении настоящей Политики конфиденциальности
							разрешаются путем переговоров, а при недостижении согласия передаются на
							рассмотрение в соответствующий суд города Москвы (по подведомственности спора).
						</li>
						<li class="privacy-policy__lvl-2-text">
							Признание судом какого-либо положения Политики конфиденциальности недействительным
							или не подлежащим принудительному исполнению не влечет недействительности иных
							положений Политики конфиденциальности.
						</li>
						<li class="privacy-policy__lvl-2-text">
							Настоящая Политика конфиденциальности вступает в силу для Пользователя с момента
							начала использования им Сайта и действует в течение неопределенного срока.
							Пользователь подтверждает, что ознакомлен со всеми пунктами настоящей Политики
							конфиденциальности и безусловно принимает их.
						</li>
					</ol>
				</li>
				<li class="privacy-policy__lvl-1-text">
					<h2 class="privacy-policy__title-lvl-1">Обратная связь, запросы, предложения</h2>
					<ol type="1" class="privacy-policy__ol-lvl-2">
						<li class="privacy-policy__lvl-2-text">
							Все предложения, запросы или вопросы по поводу настоящей Политики
							конфиденциальности Пользователь вправе направлять на адрес электронной почты
							Администрации сайта: info@appchina.ru, либо по адресу: ООО «Агентство Правильных
							Перевозок», 432027, г. Ульяновск, Казанская улица, д.1а, помещение 13 тел. +7
							(917) 621 71 08.
						</li>
					</ol>
				</li>
			</ol>
			<div class="privacy-policy__date">07 ноября 2024 года</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.privacy-policy {
		padding-top: 36px;
		padding-bottom: 120px;
	}
	.privacy-policy__page-title {
		font-size: var(--font-size-title);
		margin-bottom: 47px;
	}
	.privacy-policy__content {
	}
	.privacy-policy__content-block {
	}
	.privacy-policy__lvl-1-text {
		margin-top: 60px;
		counter-increment: section;

		&::before {
			content: counters(section, '.') '. ';
		}
	}
	.privacy-policy__title-lvl-1 {
		display: inline;
	}
	.privacy-policy__ol-lvl-2 {
		counter-reset: section;
		margin-top: 36px;
	}
	.privacy-policy__lvl-2-text {
		counter-increment: section;
		margin-bottom: 24px;
		&::before {
			content: counters(section, '.') ' ';
		}
	}
	.privacy-policy__ol-lvl-3 {
		counter-reset: section;
		margin-top: 24px;
	}
	.privacy-policy__date {
		padding: 10px 0;
		border-top: 1px solid var(--color-tertiary);
	}

	@media (min-width: 1200px) {
		.privacy-policy {
			padding-top: 36px;
			padding-bottom: 120px;
		}
		.privacy-policy__page-title {
			margin-bottom: 47px;
		}
		.privacy-policy__content {
		}
		.privacy-policy__content-block {
		}
		.privacy-policy__lvl-1-text {
			margin-top: 60px;
			counter-increment: section;

			&::before {
				content: counters(section, '.') '. ';
			}
		}
		.privacy-policy__title-lvl-1 {
		}
		.privacy-policy__ol-lvl-2 {
			counter-reset: section;
		}
		.privacy-policy__lvl-2-text {
			counter-increment: section;
			margin-bottom: 24px;
			&::before {
				content: counters(section, '.') ' ';
			}
		}
		.privacy-policy__ol-lvl-3 {
			counter-reset: section;
			margin-top: 24px;
		}
		.privacy-policy__date {
			padding: 10px 0;
			border-top: 1px solid var(--color-tertiary);
		}
	}
</style>
